import Swal from 'sweetalert2'
import './modal.css'

class ModalUtil {
  // Puro para mostrar algo correcto, informando, o mostrando error.
  showModal(type, text, title, afterClick, onClose) {
    if (type === 'loading') {
      return Swal.fire({
        title,
        html: text,
        didOpen: () => {
          Swal.showLoading()
        }
      })
    } else {
      return Swal.fire({
        title,
        text,
        icon: type,
        showConfirmButton: false,
        timer: 3000,
        didOpen: () => {
          afterClick && afterClick()
        },
        didClose: () => {
          onClose && onClose()
        },
        customClass: {
          popup: 'custom-swal2'
        }
      })
    }
  }

  /**
   * @author Brayan Salas
   * @description Method to create custom Modal with own html and his own clicks
   * @param {Object} config
   * @param {function} listeners
   * @return {*} 
   * @memberof ModalUtil
   * @example
   * ```jsx
   * const selectOption = () => {
   *  modalUtil.customModal({
   *   modalTitle: 'Nueva Sucursal',
   *   id1: 'individual-branch-office',
   *   title1: 'Carga individual',
   *   text1: 'Carga una sola tienda llenando el formulario.',
   *   image1: 'https://eticket.blob.core.windows.net/eticket-development/icons/branch-office.png',
   *   imageStyle1: '50px;',
   *   id2: 'multiple-branch-office',
   *   title2: 'Carga multiple',
   *   text2: 'Carga múltiples sucursales con un archivo de Excel.',
   *   image2: 'https://eticket.blob.core.windows.net/eticket-development/icons/multiple-branch-office.png',
   *   imageStyle2: '100px;'
   *  }, () => {
   *   document.getElementById('individual-branch-office').addEventListener('click', () => {
   *     history.push('branch-office-details');
   *     Swal.close()
   *   })
   *  })
   * }
   * ```
   */
  customModal(config, listeners) {
    return Swal.fire({
      html: `
      <div>
      <h3 class="title-modal">${config.modalTitle}</h3>
      <div class="custom-modal-container">
        <div id="${config.id1}" class="box" style="margin-right: 24px;">
          <p class="box-title">${config.title1}</p>
          <img style="width:${config.imageStyle1}" src="${config.image1}" />
          <p class="box-text">${config.text1}</p>
        </div>
        <div id="${config.id2}" class="box">
          <p class="box-title">${config.title2}</p>
          <img style="width:${config.imageStyle2}" src="${config.image2}" />
          <p class="box-text">${config.text2}</p>
        </div>
      </div>
    </div>
    `,
      showCloseButton: true,
      showConfirmButton: false,
      didOpen: () => {
        document.activeElement.blur()
        listeners()
      }
    });
  }

  /**
   * @author Isaac Martinez
   * @description Simple modal to insert as a child the content
   * @param {*} title
   * @param {*} listeners
   * @param {*} html
   * @return {*} 
   * @memberof ModalUtil
   */
  mainModal(title, listeners, html) {
    return Swal.fire({
      html: `
      <div>
      <h3 class="title-modal">${title}</h3>
      <div class="main-modal-container">
        ${html}
      </div>
    </div>
    `,
      showCloseButton: true,
      showConfirmButton: false,
      didOpen: () => {
        document.activeElement.blur()
        listeners()
      }
    })
  }

  /**
   * @author Jorge Perales
   * @date 18-09-2025
   * @description Modal to show a confirm message with custom actions
   * @param {*} title
   * @param {*} text
   * @param {*} confirmButtonText
   * @param {*} cancelButtonText
   * @param {*} onConfirm
   * @param {*} onCancel
   * @return {*} 
   * @memberof ModalUtil
   */
  showConfirmModal(
    title,
    text,
    confirmButtonText = 'Sí',
    cancelButtonText = 'No',
    onConfirm = () => {},
    onCancel = () => {}
  ) {
    return Swal.fire({
      title,
      text,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText,
      cancelButtonText,
      customClass: {
        popup: 'custom-swal2'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        onConfirm()
      } else if (result.isDismissed) {
        onCancel()
      }
    })
  }
}

export default ModalUtil